/**
 * Why does this exist? because React Router moved over to hooks exclusivly
 * They now use a useNavigate hook or useParams hook to progamatically navigate or read url params, 
 * so we have to add those hooks via props by higher order components. 
 * 
 * Trendy bullshit.... yep
 */


import { useNavigate, useParams, useSearchParams } from "react-router-dom";


export const withNavigation = ( Component ) => {

    return props => <Component {...props} navigate={useNavigate()} />;

}

export const withSearchParams = (Component)=>{

    return props =><Component {...props} searchParams={useSearchParams()[0]}/>
}

export const withParams = ( Component ) => {

    return props => <Component {...props} params={useParams()} />;
    
}

